// extracted by mini-css-extract-plugin
export default {"container":"vod_container__YbHVz","vods":"vod_vods__MiCsi"};